import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ClearIcon = withSvgIcon(
    <g>
        <path d="M281.7,31.7C166.1,31.7,71.5,122,64.1,235.8l-38.9-49.3L0,206.4l78.1,98.9l88.6-88.6L143.9,194L96,242c4.2-98.9,85.8-178.1,185.7-178.1c102.7,0,186.2,83.5,186.2,186.1c0,94-70.2,173.4-163.3,184.8c-7.6,0.9-15.3,1.4-22.8,1.4v32.2c8.8,0,17.8-0.5,26.7-1.6C417.6,453.4,500,360.2,500,250C500,129.6,402.1,31.7,281.7,31.7z" />
    </g>
);
